import { render, staticRenderFns } from "./SurveyLayout.vue?vue&type=template&id=4a892b52&scoped=true&"
import script from "./SurveyLayout.vue?vue&type=script&lang=js&"
export * from "./SurveyLayout.vue?vue&type=script&lang=js&"
import style0 from "./SurveyLayout.vue?vue&type=style&index=0&id=4a892b52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a892b52",
  null
  
)

export default component.exports